<button
    *ngIf="isPlan && showTrigger"
    type="button"
    [ngClass]="triggerVariant === 'secondary' ? 'fpp-trigger fpp-trigger--secondary px-4 rounded-3' : 'btn btn-purple px-5 rounded-3'"
    (click)="openWithMode('pay', { size: 'lg', centered: true, backdrop: 'static', keyboard: false })"
>
    Pagar ahora
</button>
<div *ngIf="!isPlan && showTrigger" class="px-5 btn-link" type="button" (click)="openWithMode('pay', { size: 'lg', centered: true, backdrop: 'static', keyboard: false })">
    Registrar pago
    <fa-icon class="icon ms-2" [icon]="['fas', 'angle-right']"></fa-icon>
</div>

<ng-template let-modal #modalForm>
    <form #Form="ngForm" class="fpp-modal-shell">
        <ng-container *ngIf="plansService.plansBundle$ | async as bundle; else payModalLoading">
            <div class="modal-header fpp-modal-header border-0 pb-0">
                <div class="w-100">
                    <ng-container [ngSwitch]="payModalStep">
                        <ng-container *ngSwitchCase="3">
                            <h5 class="modal-title fpp-modal-title d-flex align-items-center gap-2 mb-0">
                                Mejorar plan
                                <fa-icon class="fpp-title-sparkle text-purple" [icon]="['fas', 'wand-magic-sparkles']"></fa-icon>
                            </h5>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <ng-container *ngIf="showSmsSection && payModalStep === 1; else payOnlyHeader">
                                <ng-container *ngIf="showPlanSmsTabs; else smsOnlyHeader">
                                    <h5 class="modal-title fpp-modal-title mb-1">Plan y SMS</h5>
                                    <p class="fpp-modal-subtitle mb-0">Cambia tu plan o compra paquetes de SMS</p>
                                </ng-container>
                                <ng-template #smsOnlyHeader>
                                    <h5 class="modal-title fpp-modal-title mb-1">{{ isMixPurchaseFlow ? 'Confirmar compra' : 'Comprar SMS' }}</h5>
                                    <p class="fpp-modal-subtitle mb-0">{{ isMixPurchaseFlow ? 'Selecciona tu método de pago para los complementos' : 'Selecciona un paquete de SMS' }}</p>
                                </ng-template>
                            </ng-container>
                            <ng-template #payOnlyHeader>
                                <h5 class="modal-title fpp-modal-title mb-1">Confirmar pago</h5>
                                <p class="fpp-modal-subtitle mb-0" *ngIf="payModalStep === 1 || payModalStep === 2">
                                    {{
                                        isMixPurchaseFlow
                                            ? 'Selecciona tu método de pago para los complementos'
                                            : isSmsPurchaseFlow
                                            ? 'Selecciona tu método de pago para el paquete SMS'
                                            : payModalStep === 1
                                            ? 'Revisa tu plan, tus usuarios y elige cómo pagar.'
                                            : 'Selecciona tu plan y frecuencia de pago'
                                    }}
                                </p>
                            </ng-template>
                        </ng-container>
                    </ng-container>
                </div>
                <div class="box-btn-close-modal" *ngIf="!postPaymentSurveyStep && payModalStep !== 3">
                    <button (click)="modal.dismiss('Close Click')" class="btn-close-modal rounded-circle" type="button" data-dismiss="modal" aria-label="Close">
                        <img src="assets/icons/svg/icon-btn-close-modal.svg" class="" alt="icon-close" />
                    </button>
                </div>
            </div>

            <div class="modal-body fpp-modal-body pt-2">
                <!-- ====================================================================== PAY_MODAL_STEP_1 — Plan y frecuencia (extraer a componente dedicado) -->
                <!-- [hidden]/d-none en vez de *ngIf: al ir al paso 2 no destruir el paso 1 (evita cards vacías y CTAs duplicados al volver). -->
                <div class="fpp-step fpp-step--1 my-4 mx-2" [class.d-none]="payModalStep !== 1 || isMixPurchaseFlow" [attr.aria-hidden]="payModalStep !== 1 || isMixPurchaseFlow">
                    <div class="fpp-plan-sms-tabs" *ngIf="showPlanSmsTabs">
                        <button type="button" class="fpp-plan-sms-tab" [class.fpp-plan-sms-tab--active]="activePlanSmsTab === 'plan'" (click)="setPlanSmsTab('plan')">Cambiar plan</button>
                        <button type="button" class="fpp-plan-sms-tab" [class.fpp-plan-sms-tab--active]="activePlanSmsTab === 'sms'" (click)="setPlanSmsTab('sms')">Comprar SMS</button>
                    </div>

                    <!-- [hidden] en vez de *ngIf: no destruir paneles al cambiar de tab (evita recargas y pantallas vacías). -->
                    <div [hidden]="isSmsOnlyMode || (showSmsSection && activePlanSmsTab === 'sms')">
                        <div *ngIf="loadingPlans && plans.length === 0" class="fpp-skeleton" aria-busy="true" aria-label="Cargando planes">
                            <div class="fpp-plan-cards">
                                <div class="fpp-plan-card fpp-plan-card--skeleton" *ngFor="let _ of skeletonSlots">
                                    <span class="fpp-skel fpp-skel--circle"></span>
                                    <div class="fpp-plan-card__body">
                                        <div class="fpp-plan-card__copy">
                                            <span class="fpp-skel fpp-skel--title"></span>
                                            <span class="fpp-skel fpp-skel--desc"></span>
                                        </div>
                                        <span class="fpp-skel fpp-skel--price"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="fpp-section-label mt-4 mb-2">Frecuencia de pago</div>
                            <div class="fpp-frequency-row">
                                <span class="fpp-skel fpp-skel--chip" *ngFor="let _ of [1, 2, 3, 4]"></span>
                            </div>
                            <div class="fpp-summary-box fpp-summary-box--skeleton mt-4">
                                <span class="fpp-skel fpp-skel--row"></span>
                                <span class="fpp-skel fpp-skel--row"></span>
                                <span class="fpp-skel fpp-skel--row fpp-skel--row-total"></span>
                            </div>
                            <span class="fpp-skel fpp-skel--btn mt-4"></span>
                        </div>

                        <ng-container *ngIf="!loadingPlans || plans.length > 0">
                            <!-- Diseño «Confirmar pago» (ADM-646 hotfix): plan colapsable, usuarios, frecuencia, resumen y CTA fijo. -->
                            <div class="fpp-plan-picker" *ngIf="getSelectedPlan(bundle) as selectedPlan">
                                <button type="button" class="fpp-plan-picker__head" [disabled]="plans.length <= 1" [attr.aria-expanded]="showPlanList" (click)="togglePlanList()">
                                    <span class="fpp-plan-picker__copy">
                                        <span class="fpp-plan-picker__label">Tu plan</span>
                                        <span class="fpp-plan-picker__name">
                                            {{ getPlanTypeLabel(selectedPlan.type) | titlecase }}
                                            <span class="fpp-plan-picker__meta" *ngIf="planUsersLabel(selectedPlan, bundle) as usersLabel"> · {{ usersLabel }} </span>
                                        </span>
                                    </span>
                                    <span class="fpp-plan-picker__price">
                                        {{ selectedPlan.amount | currency : 'USD' : 'symbol' : '1.2-2' : 'en-US' }}<span class="fpp-plan-picker__period">/mes</span>
                                    </span>
                                    <span class="fpp-plan-picker__toggle" *ngIf="plans.length > 1">
                                        {{ showPlanList ? 'Cerrar' : 'Cambiar' }}
                                        <svg
                                            class="fpp-chevron"
                                            [class.fpp-chevron--open]="showPlanList"
                                            width="14"
                                            height="14"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2.2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            aria-hidden="true"
                                        >
                                            <path d="M6 9l6 6 6-6"></path>
                                        </svg>
                                    </span>
                                </button>
                                <div class="fpp-plan-picker__list" role="radiogroup" aria-label="Planes" *ngIf="showPlanList && plans.length > 1">
                                    <ng-container *ngFor="let plan of plans">
                                        <button
                                            type="button"
                                            role="radio"
                                            class="fpp-plan-option"
                                            [class.fpp-plan-option--active]="selectedPlanId === plan._id"
                                            [attr.aria-checked]="selectedPlanId === plan._id"
                                            (click)="pickPlanFromList(plan._id)"
                                        >
                                            <span class="fpp-plan-option__radio" [class.fpp-plan-option__radio--on]="selectedPlanId === plan._id"></span>
                                            <span class="fpp-plan-option__copy">
                                                <span class="fpp-plan-option__name">
                                                    {{ getPlanTypeLabel(plan.type) | titlecase }}
                                                    <span class="fpp-badge fpp-badge--current" *ngIf="isCurrentPlan(plan, bundle)">Actual</span>
                                                    <span class="fpp-badge fpp-badge--accent" *ngIf="isFiscalPlan(plan)">
                                                        <fa-icon class="me-1" [icon]="['fas', 'thumbs-up']"></fa-icon>
                                                        Recomendado para ti
                                                    </span>
                                                </span>
                                                <span class="fpp-plan-option__desc" *ngIf="planUsersLabel(plan, bundle) as usersLabel; else planDescription">
                                                    {{ usersLabel }}
                                                </span>
                                                <ng-template #planDescription>
                                                    <span class="fpp-plan-option__desc" *ngIf="plan.description">{{ plan.description }}</span>
                                                </ng-template>
                                            </span>
                                            <span class="fpp-plan-option__price">
                                                {{ plan.amount | currency : 'USD' : 'symbol' : '1.2-2' : 'en-US' }}<span class="fpp-plan-option__period">/mes</span>
                                            </span>
                                        </button>
                                    </ng-container>
                                </div>
                            </div>

                            <fina-extra-users-seats
                                class="fpp-section"
                                *ngIf="showExtraUsersSeats(bundle)"
                                layout="modal"
                                [seats]="bundle.seats || null"
                                [selectedIncludedSeats]="getSelectedIncludedSeats(bundle)"
                                [extraUserPriceUsd]="bundle.extraUserPriceUsd"
                                [pendingPurchasedUsers]="pendingPurchasedUsers"
                                [canEdit]="canEditExtraUsers(bundle)"
                                (pendingPurchasedUsersChange)="onPendingPurchasedUsersChange($event)"
                            ></fina-extra-users-seats>

                            <!-- Cupo fiscal extra (ADM-740): editable al pagar la renovación con destino fiscal; si no, solo lectura del vigente. -->
                            <fina-fiscal-quota-select
                                class="fpp-section"
                                *ngIf="showExtraControlNumbersSection(bundle)"
                                [options]="extraControlNumbersChoices(bundle)"
                                [value]="getRequestedExtraControlNumbers(bundle)"
                                [includedQuantity]="getFiscalIncludedQuantity(bundle)"
                                [canEdit]="canEditExtraControlNumbers(bundle)"
                                [readOnlyQuota]="getChargedFiscalQuota(bundle)"
                                (valueChange)="onExtraControlNumbersChange($event)"
                            ></fina-fiscal-quota-select>

                            <section class="fpp-section" aria-label="Frecuencia de pago">
                                <h3 class="fpp-section-title">¿Cada cuánto quieres pagar?</h3>
                                <div class="fpp-frequency-grid" role="radiogroup">
                                    <button
                                        type="button"
                                        role="radio"
                                        class="fpp-frequency-card"
                                        *ngFor="let fq of selectablePaymentFrequencyOptions"
                                        [class.fpp-frequency-card--active]="selectedPaymentFrequency === fq.id"
                                        [attr.aria-checked]="selectedPaymentFrequency === fq.id"
                                        (click)="selectFrequency(fq.id)"
                                    >
                                        <span class="fpp-frequency-card__ribbon" *ngIf="fq.id === 'yearly'">Mejor precio</span>
                                        <span class="fpp-frequency-card__label">{{ fq.label }}</span>
                                        <span class="fpp-frequency-card__price">
                                            {{ getFrequencyMonthlyPriceUsd(bundle, fq.id) | currency : 'USD' : 'symbol' : '1.2-2' : 'en-US' }}<span class="fpp-frequency-card__period">/mes</span>
                                        </span>
                                        <span class="fpp-frequency-card__badge" [class.fpp-frequency-card__badge--save]="fq.savings">{{ fq.savings || 'Sin descuento' }}</span>
                                    </button>
                                </div>
                            </section>

                            <div class="fpp-info-note fpp-info-note--info mb-0" *ngIf="isPlanChangeBlockedByPendingBill(bundle)" role="status">
                                <fa-icon class="fpp-info-note__icon" [icon]="['fas', 'circle-info']"></fa-icon>
                                <span>{{ pendingBillBlocksPlanChangeMessage }}</span>
                            </div>

                            <div class="fpp-info-note fpp-info-note--info mb-0" *ngIf="isMidCyclePlanOnlyFee(bundle)" role="status">
                                <fa-icon class="fpp-info-note__icon" [icon]="['fas', 'circle-info']"></fa-icon>
                                <span>
                                    Al solo cambiar de plan se cobra $5 por cada mes restante del ciclo ya pagado ({{ getMidCycleRemainingMonths(bundle) }}
                                    {{ getMidCycleRemainingMonths(bundle) === 1 ? 'mes' : 'meses' }}). El mes en curso cuenta completo.
                                </span>
                            </div>

                            <section class="fpp-summary-box fpp-section" aria-label="Resumen">
                                <h3 class="fpp-summary-title">Resumen · {{ getSelectedFrequencyLabel() }}</h3>
                                <div class="fpp-summary-row">
                                    <span *ngIf="isMidCyclePlanOnlyFee(bundle); else planPeriodLabel">Cambio de plan</span>
                                    <ng-template #planPeriodLabel>
                                        <span>
                                            {{ getPlanTypeLabel(getSelectedPlan(bundle)?.type) | titlecase }} ×
                                            {{ getMonthsForFrequency() === 1 ? '1 mes' : getMonthsForFrequency() + ' meses' }}
                                        </span>
                                    </ng-template>
                                    <span>{{ getSummarySubtotalUsd(bundle) | currency : 'USD' : 'symbol' : '1.2-2' : 'en-US' }}</span>
                                </div>
                                <div class="fpp-summary-row fpp-summary-row--saving" *ngIf="getFrequencyDiscountUsd(bundle) > 0">
                                    <span>Ahorro por pago {{ getSelectedFrequencyLabel() | lowercase }} (−{{ getFrequencyDiscountPercent() }}%)</span>
                                    <span>−{{ getFrequencyDiscountUsd(bundle) | currency : 'USD' : 'symbol' : '1.2-2' : 'en-US' }}</span>
                                </div>
                                <div class="fpp-summary-row" *ngIf="getExtraUsersBaseUsd(bundle) !== 0">
                                    <span>
                                        {{ getSummaryExtraSeatsCount(bundle) }} {{ getSummaryExtraSeatsCount(bundle) === 1 ? 'cupo adicional' : 'cupos adicionales' }} ×
                                        {{ getMonthsForFrequency() === 1 ? '1 mes' : getMonthsForFrequency() + ' meses'
                                        }}{{ getFrequencyDiscountPercent() > 0 ? ' (−' + getFrequencyDiscountPercent() + '%)' : '' }}
                                    </span>
                                    <span>{{ getExtraUsersBaseUsd(bundle) | currency : 'USD' : 'symbol' : '1.2-2' : 'en-US' }}</span>
                                </div>
                                <!-- Cupo fiscal extra (ADM-740). Paridad: misma fila en #planInvoiceSummary del paso 2. -->
                                <div class="fpp-summary-row" *ngIf="getExtraControlNumbersBaseUsd(bundle) !== 0">
                                    <span>
                                        +{{ getChargedFiscalQuota(bundle)?.quantity }} números de control adicionales × {{ getMonthsForFrequency() === 1 ? '1 mes' : getMonthsForFrequency() + ' meses'
                                        }}{{ getFrequencyDiscountPercent() > 0 ? ' (−' + getFrequencyDiscountPercent() + '%)' : '' }}
                                    </span>
                                    <span>{{ getExtraControlNumbersBaseUsd(bundle) | currency : 'USD' : 'symbol' : '1.2-2' : 'en-US' }}</span>
                                </div>
                                <div class="fpp-summary-row" *ngIf="getCouponDiscountUsd() > 0">
                                    <span class="fpp-summary-coupon-label">
                                        <span>{{ getCouponSummaryLabel() }}</span>
                                        <button type="button" class="fpp-coupon-remove-inline" *ngIf="!isCouponRemovalBlocked" (click)="removeCoupon()">Quitar</button>
                                    </span>
                                    <span class="text-success">-{{ getCouponDiscountUsd() | currency : 'USD' : 'symbol' : '1.2-2' : 'en-US' }}</span>
                                </div>
                                <div class="fpp-summary-row" *ngIf="getCreditDiscountUsd(bundle) > 0">
                                    <span>Saldo a favor</span>
                                    <span class="text-success">-{{ getCreditDiscountUsd(bundle) | currency : 'USD' : 'symbol' : '1.2-2' : 'en-US' }}</span>
                                </div>
                                <div class="fpp-summary-row" *ngIf="getSummaryIvaUsd(bundle) > 0">
                                    <span>IVA (16%)</span>
                                    <span>{{ getSummaryIvaUsd(bundle) | currency : 'USD' : 'symbol' : '1.2-2' : 'en-US' }}</span>
                                </div>
                                <div class="fpp-summary-row" *ngIf="getSummaryRetentionUsd() > 0">
                                    <span>Retención de IVA</span>
                                    <span class="text-success">-{{ getSummaryRetentionUsd() | currency : 'USD' : 'symbol' : '1.2-2' : 'en-US' }}</span>
                                </div>

                                <!-- Cupón de descuento: enlace que se expande dentro del resumen, antes del total. -->
                                <ng-container *ngIf="canRedeemCoupon(bundle)">
                                    <button type="button" class="fpp-coupon-link" *ngIf="!isCouponPanelOpen" (click)="openCouponPanel()">
                                        <span>¿Tienes un código de descuento?</span>
                                    </button>

                                    <div class="fpp-coupon-panel" *ngIf="isCouponPanelOpen">
                                        <div class="fpp-coupon-panel__title">Código de descuento</div>
                                        <div class="fpp-coupon-field">
                                            <input
                                                type="text"
                                                class="form-control fpp-coupon-input"
                                                placeholder="Ingresa tu código"
                                                autocomplete="off"
                                                maxlength="32"
                                                aria-label="Código de descuento"
                                                [value]="couponCodeInput"
                                                [readOnly]="isCouponRemovalBlocked"
                                                (input)="onCouponCodeInput($event.target.value)"
                                                (keydown.space)="$event.preventDefault()"
                                            />
                                            <span class="fpp-coupon-field__status" *ngIf="isValidatingCoupon || isSealingCoupon">
                                                <span class="spinner-border spinner-border-sm" role="status" aria-label="Validando código"></span>
                                            </span>
                                        </div>
                                        <div class="fpp-coupon-error" *ngIf="couponError" role="alert">
                                            <span class="fpp-coupon-error__mark">!</span>
                                            <span>{{ couponError }}</span>
                                        </div>
                                        <div class="fpp-coupon-applied" *ngIf="appliedCoupon" role="status">
                                            <span class="fpp-coupon-applied__text">{{ getAppliedCouponMessage() }}</span>
                                            <button type="button" class="fpp-coupon-remove" *ngIf="!isCouponRemovalBlocked" (click)="removeCoupon()">Quitar</button>
                                        </div>
                                    </div>
                                </ng-container>

                                <div class="fpp-summary-row fpp-summary-row--total">
                                    <span>Total a pagar</span>
                                    <span>{{ getSummaryTotalUsd(bundle) | currency : 'USD' : 'symbol' : '1.2-2' : 'en-US' }}</span>
                                </div>
                            </section>

                            <div class="fpp-step1-footer" *ngIf="!isSmsOnlyMode && (!showSmsSection || activePlanSmsTab === 'plan')">
                                <button type="button" class="btn btn-purple fpp-btn-primary w-100" [disabled]="!canProceedToPayment(bundle) || !canAdvanceWithCoupon()" (click)="goToPaymentStep()">
                                    Pagar {{ getSummaryTotalUsd(bundle) | currency : 'USD' : 'symbol' : '1.2-2' : 'en-US' }}
                                    <fa-icon class="ms-2" [icon]="['fas', 'arrow-right']"></fa-icon>
                                </button>
                                <p class="body-text body-text--muted text-center mt-2 mb-0" *ngIf="isMidCycleChange(bundle) && !canProceedToPayment(bundle)">
                                    Cambia el plan o la frecuencia para continuar.
                                </p>
                                <p class="body-text body-text--muted text-center mt-2 mb-0" *ngIf="isPlanChangeBlockedByPendingBill(bundle) && !canProceedToPayment(bundle)">
                                    Vuelve a tu plan actual para pagar la factura pendiente.
                                </p>
                            </div>
                        </ng-container>
                    </div>

                    <div *ngIf="showSmsSection" [hidden]="!isSmsOnlyMode && activePlanSmsTab !== 'sms'">
                        <fina-sms-messages layout="modal" [selectedPackageId]="selectedSmsPackage?.id || ''" (selectedPackageChange)="onSmsPackageSelected($event)"></fina-sms-messages>
                        <button
                            type="button"
                            class="btn btn-purple fpp-btn-primary mt-4 w-100"
                            *ngIf="isSmsOnlyMode || activePlanSmsTab === 'sms'"
                            [disabled]="!selectedSmsPackage"
                            (click)="proceedSmsPurchase()"
                        >
                            Proceder al pago
                            <fa-icon class="ms-2" [icon]="['fas', 'arrow-right']"></fa-icon>
                        </button>
                    </div>
                </div>

                <!-- ====================================================================== PAY_MODAL_STEP_2 — Método y reporte (extraer a componente dedicado) -->
                <div *ngIf="payModalStep === 2" class="fpp-step fpp-step--2 my-4 mx-2">
                    <ng-container *ngIf="!postPaymentSurveyStep; else postPaymentSurveyContent">
                        <button type="button" class="btn btn-link fpp-back-link p-0 text-start d-flex align-items-center mb-3" (click)="goBackToPlanStep()">< Atrás</button>

                        <div class="fpp-chosen-banner">
                            <div class="fpp-chosen-banner__row">
                                <div class="fpp-chosen-banner__left">
                                    <div class="fpp-chosen-banner__esc">Escogiste:</div>
                                    <ng-container *ngIf="isMixPurchaseFlow">
                                        <div class="fpp-chosen-banner__plan">Complementos</div>
                                        <ul class="fpp-chosen-banner__items">
                                            <li *ngFor="let item of getMixPurchaseItems()">{{ item }}</li>
                                        </ul>
                                    </ng-container>
                                    <ng-container *ngIf="!isMixPurchaseFlow && isSmsPurchaseFlow">
                                        <div class="fpp-chosen-banner__plan">{{ getSmsPurchaseTitle() }}</div>
                                        <p class="fpp-chosen-banner__sub">{{ getSmsPurchaseSubtitle() }}</p>
                                    </ng-container>
                                    <ng-container *ngIf="!isMixPurchaseFlow && !isSmsPurchaseFlow">
                                        <div class="fpp-chosen-banner__plan">{{ getSelectedPlanTitle(bundle) }}</div>
                                        <p class="fpp-chosen-banner__sub">{{ getSelectedPlanSubtitle(bundle) }}</p>
                                    </ng-container>
                                </div>
                                <div class="fpp-chosen-banner__price" *ngIf="(isSmsPurchaseFlow || isMixPurchaseFlow) && !(isMixPurchaseFlow && refreshingMixRate)">
                                    <span class="fpp-chosen-banner__amount">{{
                                        getAmountInPaymentMethodCurrency() | currency : getStep2CurrencyCode() : 'symbol' : '1.0-0' : getStep2CurrencyLocale()
                                    }}</span>
                                </div>
                                <div class="fpp-chosen-banner__price" *ngIf="!isSmsPurchaseFlow && !isMixPurchaseFlow && getSelectedPlan(bundle) as sp">
                                    <ng-container *ngIf="selectedPaymentFrequency === 'monthly'; else fppChosenPeriodPrice">
                                        <span class="fpp-chosen-banner__strike text-decoration-line-through" *ngIf="(sp.amountDiscount ?? 0) > 0">{{
                                            getUsdAsStep2DisplayCurrency(sp.amount + (sp.amountDiscount ?? 0)) | currency : getStep2CurrencyCode() : 'symbol' : '1.0-0' : getStep2CurrencyLocale()
                                        }}</span>
                                        <span class="fpp-chosen-banner__amount">{{
                                            getAmountInPaymentMethodCurrency() | currency : getStep2CurrencyCode() : 'symbol' : '1.0-0' : getStep2CurrencyLocale()
                                        }}</span>
                                        <span class="fpp-chosen-banner__period">/mes</span>
                                    </ng-container>
                                    <ng-template #fppChosenPeriodPrice>
                                        <span class="fpp-chosen-banner__strike text-decoration-line-through" *ngIf="getSummaryDiscountUsd(bundle) > 0">{{
                                            getUsdAsStep2DisplayCurrency(getSummarySubtotalUsd(bundle)) | currency : getStep2CurrencyCode() : 'symbol' : '1.0-0' : getStep2CurrencyLocale()
                                        }}</span>
                                        <span class="fpp-chosen-banner__amount">{{
                                            getAmountInPaymentMethodCurrency() | currency : getStep2CurrencyCode() : 'symbol' : '1.0-0' : getStep2CurrencyLocale()
                                        }}</span>
                                        <span class="fpp-chosen-banner__period">{{ getFrequencyPeriodLabel() }}</span>
                                    </ng-template>
                                </div>
                            </div>
                        </div>

                        <!-- Migración a facturación formal: la cuenta de cobro cambió de
                             Bancrecer (personal) a BNC (empresa). Muchos comercios tienen la
                             vieja guardada en su banco, así que el aviso va antes de que
                             elijan método, no después. -->
                        <div class="fpp-info-note fpp-info-note--warning mt-4 mb-0" *ngIf="!loadingPaymentMethods && migrationNotice.bankAccountChanged" role="alert">
                            <fa-icon class="fpp-info-note__icon" [icon]="['fas', 'triangle-exclamation']"></fa-icon>
                            <span>
                                <b>Cambiamos nuestra cuenta bancaria.</b> Verifica los datos de abajo antes de pagar y <b>no uses la cuenta que tengas guardada</b> en tu banco: los pagos a la cuenta
                                anterior no se registran automáticamente.
                            </span>
                        </div>

                        <!-- Datos fiscales: los comercios recién migrados no tienen RIF
                             cargado y sin RIF no se les puede emitir la factura fiscal del
                             pago que están por hacer, así que va antes de elegir método y
                             bloquea las tres vías de pago hasta que lo guarden. -->
                        <div class="fpp-fiscal-form mt-4 mb-3" *ngIf="!loadingPaymentMethods && migrationNotice.requiresFiscalInfo">
                            <div class="fpp-fiscal-form__header">
                                <fa-icon class="fpp-fiscal-form__icon" [icon]="['fas', 'file-invoice']"></fa-icon>
                                <div>
                                    <div class="fpp-fiscal-form__title">Necesitamos actualizar los datos de facturación de tu negocio</div>
                                    <div class="fpp-fiscal-form__subtitle">Solo tendrás que llenarlo una vez. Guárdalos para continuar con tu pago.</div>
                                </div>
                            </div>
                            <div class="row g-2 mt-2">
                                <div class="col-4 col-sm-3">
                                    <label class="fpp-fiscal-form__label" for="fiscalTaxIdType">Tipo</label>
                                    <select id="fiscalTaxIdType" name="fiscalTaxIdType" class="form-control fpp-input" [(ngModel)]="fiscalForm.taxIdType" [disabled]="savingFiscalInfo">
                                        <option *ngFor="let t of taxIdTypes" [value]="t">{{ t }}</option>
                                    </select>
                                </div>
                                <div class="col-8 col-sm-9">
                                    <label class="fpp-fiscal-form__label" for="fiscalTaxIdNumber">Número de RIF o cédula</label>
                                    <input
                                        id="fiscalTaxIdNumber"
                                        name="fiscalTaxIdNumber"
                                        class="form-control fpp-input"
                                        type="text"
                                        inputmode="numeric"
                                        placeholder="401234567"
                                        [(ngModel)]="fiscalForm.taxIdNumber"
                                        [class.is-invalid]="fiscalTaxIdError"
                                        [disabled]="savingFiscalInfo"
                                    />
                                    <div class="fpp-fiscal-form__error" *ngIf="fiscalTaxIdError">{{ fiscalTaxIdError }}</div>
                                </div>
                                <div class="col-12">
                                    <label class="fpp-fiscal-form__label" for="fiscalAddress">Dirección fiscal</label>
                                    <input
                                        id="fiscalAddress"
                                        name="fiscalAddress"
                                        class="form-control fpp-input"
                                        type="text"
                                        placeholder="Dirección que aparece en tu RIF"
                                        [(ngModel)]="fiscalForm.address"
                                        [disabled]="savingFiscalInfo"
                                    />
                                </div>
                            </div>
                            <button type="button" class="btn btn-primary fpp-fiscal-form__submit mt-3" [disabled]="!isFiscalFormValid || savingFiscalInfo" (click)="saveFiscalInfo()">
                                {{ savingFiscalInfo ? 'Guardando...' : 'Guardar datos fiscales' }}
                            </button>
                        </div>

                        <div class="fpp-info-note fpp-info-note--success mt-4 mb-3" *ngIf="fiscalInfoSaved" role="status">
                            <fa-icon class="fpp-info-note__icon" [icon]="['fas', 'circle-check']"></fa-icon>
                            <span>Recibimos tus datos fiscales. Ya puedes continuar con tu pago.</span>
                        </div>

                        <div class="fpp-section-label fpp-section-label--step2 mt-4 mb-2">Selecciona tu método de pago</div>
                        <div *ngIf="loadingPaymentMethods" class="fpp-payment-methods fpp-payment-methods--stack fpp-skeleton mb-3" aria-busy="true" aria-label="Cargando métodos de pago">
                            <div class="fpp-pm-card fpp-pm-card--row fpp-pm-card--skeleton" *ngFor="let _ of skeletonSlots">
                                <span class="fpp-skel fpp-skel--circle"></span>
                                <div class="fpp-pm-card__body">
                                    <span class="fpp-skel fpp-skel--title"></span>
                                    <span class="fpp-skel fpp-skel--desc"></span>
                                </div>
                            </div>
                        </div>
                        <!-- Orden: primero los métodos que cobran solos (débito
                             inmediato, tarjeta) y de último los que obligan al
                             comercio a transferir por fuera y volver a pegar la
                             referencia. -->
                        <div *ngIf="!loadingPaymentMethods" class="fpp-payment-methods fpp-payment-methods--stack mb-3">
                            <!-- Débito inmediato (BNC): paga en bolívares desde su
                                 cuenta con una clave que le manda el banco. -->
                            <div *ngIf="isDebitoInmediatoEligible()">
                                <button
                                    type="button"
                                    class="fpp-pm-card fpp-pm-card--row fpp-pm-card--badged"
                                    [class.fpp-pm-card--active]="debitoInmediatoSelected"
                                    [class.fpp-pm-card--disabled]="!canPickPaymentMethod"
                                    [disabled]="!canPickPaymentMethod"
                                    (click)="canPickPaymentMethod ? selectDebitoInmediatoMethod() : null"
                                >
                                    <span class="fpp-pm-card__badge">
                                        <fa-icon class="fpp-pm-card__badge-icon" [icon]="['fas', 'bolt']"></fa-icon>
                                        Automático
                                    </span>
                                    <span class="fpp-pm-card__icon fpp-pm-card__icon--fa">
                                        <fa-icon [icon]="['fas', 'bolt']"></fa-icon>
                                    </span>
                                    <div class="fpp-pm-card__body">
                                        <div class="fpp-pm-card__name">Débito inmediato</div>
                                        <div class="fpp-pm-card__hint">Paga al instante desde tu cuenta, sin transferir</div>
                                    </div>
                                </button>
                            </div>

                            <!-- Un solo aviso: cupos primero y luego el cupo fiscal (ADM-743 / ADM-740). -->
                            <ng-container *ngIf="isCardMethodEligible()">
                                <div class="fpp-info-note fpp-info-note--info mb-0" *ngIf="cardBlockedByCouponMessage(bundle) as cardBlockedMessage" role="status">
                                    <fa-icon class="fpp-info-note__icon" [icon]="['fas', 'circle-info']"></fa-icon>
                                    <span>{{ cardBlockedMessage }}</span>
                                </div>
                            </ng-container>

                            <div *ngIf="isCardMethodEligible() && canUseCardForSelection(bundle)">
                                <button
                                    type="button"
                                    class="fpp-pm-card fpp-pm-card--row fpp-pm-card--badged"
                                    [class.fpp-pm-card--active]="cardMethodSelected"
                                    [class.fpp-pm-card--disabled]="!canPickPaymentMethod"
                                    [disabled]="!canPickPaymentMethod"
                                    (click)="canPickPaymentMethod ? selectCardMethod() : null"
                                >
                                    <span class="fpp-pm-card__badge">
                                        <fa-icon class="fpp-pm-card__badge-icon" [icon]="['fas', 'bolt']"></fa-icon>
                                        Automático
                                    </span>
                                    <span class="fpp-pm-card__icon fpp-pm-card__icon--fa">
                                        <fa-icon [icon]="['far', 'credit-card']"></fa-icon>
                                    </span>
                                    <div class="fpp-pm-card__body">
                                        <div class="fpp-pm-card__name">Tarjeta en dólares</div>
                                        <div class="fpp-pm-card__hint">{{ isSmsPurchaseFlow ? 'Paga tu paquete de SMS al instante' : 'Guarda una tarjeta y olvídate de pagar cada mes' }}</div>
                                    </div>
                                </button>
                            </div>

                            <ng-container *ngIf="!hasSavedCard || showAllMethods || !canUseCardForSelection(bundle)">
                                <div *ngFor="let paymentsMethod of paymentMethods; let i = index">
                                    <ng-container *ngIf="paymentsMethod.plus === commerceService.commerce.plus || (!commerceService.commerce.plus && paymentsMethod.plus === false)">
                                        <button
                                            type="button"
                                            class="fpp-pm-card fpp-pm-card--row"
                                            [class.fpp-pm-card--active]="pagoMovilSelected && i === indexSelected"
                                            [class.fpp-pm-card--disabled]="!canPickPaymentMethod"
                                            [disabled]="!canPickPaymentMethod"
                                            (click)="canPickPaymentMethod ? onChangePayment(paymentsMethod._id, i) : null"
                                        >
                                            <img class="fpp-pm-card__icon" [src]="paymentsMethod.imgUrl" [alt]="paymentsMethod.name" />
                                            <div class="fpp-pm-card__body">
                                                <div class="fpp-pm-card__name">{{ paymentsMethod.name }}</div>
                                                <div class="fpp-pm-card__hint">Paga con pago móvil</div>
                                            </div>
                                        </button>
                                    </ng-container>
                                </div>
                            </ng-container>
                        </div>

                        <button
                            type="button"
                            *ngIf="hasSavedCard && canUseCardForSelection(bundle) && !showAllMethods && !isValidated"
                            class="btn btn-link fpp-change-method-link p-0 mb-3"
                            (click)="revealAllPaymentMethods()"
                        >
                            Cambiar método de pago
                        </button>

                        <div class="fpp-coupon-error mb-3" *ngIf="couponError" role="alert">
                            <span class="fpp-coupon-error__mark">!</span>
                            <span>{{ couponError }}</span>
                        </div>

                        <!-- El monto lo cotiza el servidor a partir de la factura, del
                             cambio de plan/frecuencia y de los cupos pedidos: acá no se
                             le pasa ninguno. -->
                        <div *ngIf="debitoInmediatoSelected" class="mb-3">
                            <fina-debito-inmediato-payment
                                [billPlanId]="payFormData.billPlanId"
                                [planType]="getCardPayPlanType()"
                                [paymentFrequency]="getCardPayPaymentFrequency()"
                                [pendingPurchasedUsers]="hasExtraUsersIntent(bundle) ? pendingPurchasedUsers : null"
                                [pendingBlockUserIds]="hasExtraUsersIntent(bundle) ? pendingBlockUserIds : null"
                                [extraControlNumbers]="hasExtraControlNumbersIntent(bundle) ? getRequestedExtraControlNumbers(bundle) : null"
                                (paid)="onDebitoInmediatoPaid()"
                                (chargeUnresolved)="onDebitoInmediatoUnresolved()"
                                (chargeInFlight)="onDebitoInmediatoChargeInFlight($event)"
                                (fiscalQuotaConflict)="onFiscalQuotaConflict($event, 'debito_inmediato')"
                            ></fina-debito-inmediato-payment>
                        </div>

                        <div *ngIf="cardMethodSelected && canUseCardForSelection(bundle)" class="mb-3">
                            <fina-auto-pay-card
                                [billPlanId]="isSmsPurchaseFlow || isMixPurchaseFlow ? null : payFormData.billPlanId"
                                [amount]="payFormData.amount"
                                [planType]="isSmsPurchaseFlow || isMixPurchaseFlow ? null : getCardPayPlanType()"
                                [paymentFrequency]="isSmsPurchaseFlow || isMixPurchaseFlow ? null : getCardPayPaymentFrequency()"
                                [pendingPurchasedUsers]="hasExtraUsersIntent(bundle) ? pendingPurchasedUsers : null"
                                [pendingBlockUserIds]="hasExtraUsersIntent(bundle) ? pendingBlockUserIds : null"
                                [extraControlNumbers]="hasExtraControlNumbersIntent(bundle) ? getRequestedExtraControlNumbers(bundle) : null"
                                [smsQuantity]="isSmsPurchaseFlow ? selectedSmsPackage?.quantity ?? null : null"
                                [mixSmsQuantity]="isMixPurchaseFlow ? mixCart?.smsQuantity ?? null : null"
                                [mixExtraUsersToAdd]="isMixPurchaseFlow ? mixCart?.extraUsersToAdd ?? null : null"
                                [mixIncludeSetup]="isMixPurchaseFlow ? mixCart?.includeSetup === true : false"
                                [mixControlNumbers]="isMixPurchaseFlow ? mixCart?.controlNumbersQuantity ?? null : null"
                                [autoOpenForm]="true"
                                [beforePay]="sealCouponBeforeCardPay"
                                (paid)="onCardPaid($event)"
                                (chargeUnresolved)="onCardChargeUnresolved($event)"
                                (couponHoldExpired)="onCouponHoldExpiredFromCard($event)"
                                (chargeFailed)="onCardChargeFailed()"
                                (mixChargeIssue)="onMixChargeIssue($event)"
                                (fiscalQuotaConflict)="onFiscalQuotaConflict($event, 'card')"
                            ></fina-auto-pay-card>
                        </div>

                        <ng-container *ngIf="pagoMovilSelected">
                            <div class="fpp-finance-grid row g-3 align-items-stretch">
                                <div class="col-md-6">
                                    <div class="fpp-summary-box fpp-summary-box--invoice h-100" *ngIf="isSmsPurchaseFlow || isMixPurchaseFlow; else planInvoiceSummary">
                                        <!-- Mix con la tasa BCV recargándose: ningún monto (en Bs) se muestra con la tasa vieja. -->
                                        <ng-container *ngIf="!(isMixPurchaseFlow && refreshingMixRate); else mixRateRefreshing">
                                            <!-- Desglose del mix: mismas `lines` que el aside de «Mejora tu Fina» (paridad de filas). -->
                                            <div class="fpp-summary-row fpp-summary-row--mix-line" *ngFor="let line of mixSummaryLines">
                                                <span *ngIf="line.quantity != null; else mixLinePlainLabel">{{ line.quantity | number }} {{ mixLineUnit(line) }}</span>
                                                <ng-template #mixLinePlainLabel>
                                                    <span>{{ line.label }}</span>
                                                </ng-template>
                                                <span>{{ getUsdAsStep2DisplayCurrency(line.baseUsd) | currency : getStep2CurrencyCode() : 'symbol' : '1.2-2' : getStep2CurrencyLocale() }}</span>
                                            </div>
                                            <div class="fpp-summary-row">
                                                <span>Subtotal</span>
                                                <span>{{ getUsdAsStep2DisplayCurrency(getSmsSubtotalUsd()) | currency : getStep2CurrencyCode() : 'symbol' : '1.2-2' : getStep2CurrencyLocale() }}</span>
                                            </div>
                                            <div class="fpp-summary-row" *ngIf="getSmsIvaUsd() > 0">
                                                <span>IVA (16%)</span>
                                                <span>{{ getUsdAsStep2DisplayCurrency(getSmsIvaUsd()) | currency : getStep2CurrencyCode() : 'symbol' : '1.2-2' : getStep2CurrencyLocale() }}</span>
                                            </div>
                                            <div class="fpp-summary-row" *ngIf="isMixPurchaseFlow && getMixRetentionUsd() > 0">
                                                <span>Retención de IVA</span>
                                                <span class="fpp-summary-discount"
                                                    >-{{ getUsdAsStep2DisplayCurrency(getMixRetentionUsd()) | currency : getStep2CurrencyCode() : 'symbol' : '1.2-2' : getStep2CurrencyLocale() }}</span
                                                >
                                            </div>
                                            <div class="fpp-summary-row fpp-summary-row--invoice-total">
                                                <span class="fpp-summary-invoice-label">Total factura</span>
                                                <span class="fpp-summary-invoice-amount">{{
                                                    getAmountInPaymentMethodCurrency() | currency : getStep2CurrencyCode() : 'symbol' : '1.2-2' : getStep2CurrencyLocale()
                                                }}</span>
                                            </div>
                                        </ng-container>
                                        <ng-template #mixRateRefreshing>
                                            <div class="fpp-summary-row fpp-summary-row--invoice-total">
                                                <span class="fpp-summary-invoice-label">Actualizando tasa BCV…</span>
                                                <span class="fpp-summary-invoice-amount">
                                                    <span class="spinner-border spinner-border-sm" role="status"></span>
                                                </span>
                                            </div>
                                        </ng-template>
                                    </div>
                                    <ng-template #planInvoiceSummary>
                                        <div class="fpp-summary-box fpp-summary-box--invoice h-100">
                                            <div class="fpp-summary-row">
                                                <span>Subtotal</span>
                                                <span>{{
                                                    getUsdAsStep2DisplayCurrency(getSummarySubtotalUsd(bundle)) | currency : getStep2CurrencyCode() : 'symbol' : '1.2-2' : getStep2CurrencyLocale()
                                                }}</span>
                                            </div>
                                            <div class="fpp-summary-row" *ngIf="getFrequencyDiscountUsd(bundle) > 0">
                                                <span>Descuento por frecuencia ({{ getFrequencyDiscountPercent() }}%)</span>
                                                <span class="fpp-summary-discount"
                                                    >-{{
                                                        getUsdAsStep2DisplayCurrency(getFrequencyDiscountUsd(bundle))
                                                            | currency : getStep2CurrencyCode() : 'symbol' : '1.2-2' : getStep2CurrencyLocale()
                                                    }}</span
                                                >
                                            </div>
                                            <div class="fpp-summary-row" *ngIf="getExtraUsersBaseUsd(bundle) !== 0">
                                                <span>Usuarios extra</span>
                                                <span>{{
                                                    getUsdAsStep2DisplayCurrency(getExtraUsersBaseUsd(bundle)) | currency : getStep2CurrencyCode() : 'symbol' : '1.2-2' : getStep2CurrencyLocale()
                                                }}</span>
                                            </div>
                                            <div class="fpp-summary-row" *ngIf="getExtraControlNumbersBaseUsd(bundle) !== 0">
                                                <span>Números de control adicionales</span>
                                                <span>{{
                                                    getUsdAsStep2DisplayCurrency(getExtraControlNumbersBaseUsd(bundle))
                                                        | currency : getStep2CurrencyCode() : 'symbol' : '1.2-2' : getStep2CurrencyLocale()
                                                }}</span>
                                            </div>
                                            <div class="fpp-summary-row" *ngIf="getCouponDiscountUsd() > 0">
                                                <span>{{ getCouponSummaryLabel() }}</span>
                                                <span class="fpp-summary-discount"
                                                    >-{{
                                                        getUsdAsStep2DisplayCurrency(getCouponDiscountUsd()) | currency : getStep2CurrencyCode() : 'symbol' : '1.2-2' : getStep2CurrencyLocale()
                                                    }}</span
                                                >
                                            </div>
                                            <div class="fpp-summary-row" *ngIf="getCreditDiscountUsd(bundle) > 0">
                                                <span>Saldo a favor</span>
                                                <span class="fpp-summary-discount"
                                                    >-{{
                                                        getUsdAsStep2DisplayCurrency(getCreditDiscountUsd(bundle)) | currency : getStep2CurrencyCode() : 'symbol' : '1.2-2' : getStep2CurrencyLocale()
                                                    }}</span
                                                >
                                            </div>
                                            <div class="fpp-summary-row" *ngIf="getSummaryIvaUsd(bundle) > 0">
                                                <span>IVA (16%)</span>
                                                <span>{{
                                                    getUsdAsStep2DisplayCurrency(getSummaryIvaUsd(bundle)) | currency : getStep2CurrencyCode() : 'symbol' : '1.2-2' : getStep2CurrencyLocale()
                                                }}</span>
                                            </div>
                                            <div class="fpp-summary-row" *ngIf="getSummaryRetentionUsd() > 0">
                                                <span>Retención de IVA</span>
                                                <span class="fpp-summary-discount"
                                                    >-{{
                                                        getUsdAsStep2DisplayCurrency(getSummaryRetentionUsd()) | currency : getStep2CurrencyCode() : 'symbol' : '1.2-2' : getStep2CurrencyLocale()
                                                    }}</span
                                                >
                                            </div>
                                            <div class="fpp-summary-row fpp-summary-row--invoice-total">
                                                <span class="fpp-summary-invoice-label">Total factura</span>
                                                <span class="fpp-summary-invoice-amount">{{
                                                    getAmountInPaymentMethodCurrency() | currency : getStep2CurrencyCode() : 'symbol' : '1.2-2' : getStep2CurrencyLocale()
                                                }}</span>
                                            </div>
                                        </div>
                                    </ng-template>
                                </div>
                                <div class="col-md-6">
                                    <div class="fpp-data-panel fpp-data-panel--invoice h-100">
                                        <div class="fpp-data-panel__title">Datos</div>
                                        <div class="fpp-data-plain" *ngIf="paymentMethodSelected?.name">{{ paymentMethodSelected.name }}</div>
                                        <div class="fpp-data-plain" *ngIf="paymentMethodSelected?.ownerName">{{ paymentMethodSelected.ownerName }}</div>
                                        <div class="fpp-data-plain" *ngIf="paymentMethodSelected?.dni">{{ paymentMethodSelected.dni }}</div>
                                        <div class="fpp-data-plain" *ngIf="paymentMethodSelected?.phone">{{ paymentMethodSelected.phone }}</div>
                                    </div>
                                </div>
                            </div>

                            <div class="fpp-rate-pill-wrap my-3" *ngIf="paymentMethodSelected?.currency?.code === 'VES' && !(isMixPurchaseFlow && refreshingMixRate)">
                                <span class="fpp-rate-pill fpp-rate-pill--centered">
                                    Tasa BCV{{ isMixPurchaseFlow && mixDayRate?.rate != null ? ' del ' + mixRateDayLabel : '' }} Bs.
                                    {{ payFormData.exchangeRateBCV | number : (isMixPurchaseFlow ? '1.2-4' : '1.2-2') }}
                                </span>
                                <!-- La tasa del día elegido no cargó: se cotiza con la de hoy y decide el servidor (no bloquea). -->
                                <p class="text-muted small text-center mt-2 mb-0" *ngIf="isMixPurchaseFlow && mixDayRate && mixDayRate.rate == null" role="status">
                                    No pudimos cargar la tasa BCV del {{ mixRateDayLabel }}; se muestra la de hoy. Si transferiste ese día, el monto puede no coincidir y el pago quedaría en revisión.
                                </p>
                            </div>

                            <div class="mt-2 mb-3">
                                <label class="form-label fpp-label" for="date"><b>Fecha de pago</b></label>
                                <div class="row g-2">
                                    <div class="col-12">
                                        <div class="dp-hidden position-absolute">
                                            <div class="input-group">
                                                <input
                                                    name="datepicker"
                                                    class="form-control"
                                                    ngbDatepicker
                                                    #datepicker="ngbDatepicker"
                                                    [autoClose]="'outside'"
                                                    (dateSelect)="onDateSelection($event, datepicker)"
                                                    [displayMonths]="1"
                                                    [dayTemplate]="t"
                                                    outsideDays="hidden"
                                                    [startDate]="fromDate!"
                                                    [maxDate]="maxDate"
                                                    [disabled]="isSmsPurchaseFlow"
                                                    tabindex="-1"
                                                />
                                                <ng-template #t let-date let-focused="focused">
                                                    <span class="custom-day" [class.focused]="focused" (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null">
                                                        {{ date.day }}
                                                    </span>
                                                </ng-template>
                                            </div>
                                        </div>
                                        <div class="input-group">
                                            <input
                                                #dpFromDate="ngModel"
                                                class="form-control fpp-input"
                                                placeholder="Año-Mes-Día"
                                                name="dpFromDate"
                                                required
                                                [disabled]="isSmsPurchaseFlow"
                                                [ngModel]="paymentDateInput"
                                                (input)="onPaymentDateInput($event)"
                                                (change)="onDateSelection(null, null)"
                                            />
                                            <button class="btn btn-outline-secondary fpp-input-addon" [disabled]="isSmsPurchaseFlow" (click)="datepicker.toggle()" type="button">
                                                <fa-icon class="text-gray-200" [icon]="['fas', 'calendar']"></fa-icon>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mb-3">
                                <label class="form-label fpp-label fpp-label--muted" for="ref">Número de referencia <span class="fpp-label-hint">(solo los últimos 6 dígitos)</span></label>
                                <div class="row g-2">
                                    <div class="col-8">
                                        <input
                                            class="form-control fpp-input"
                                            required
                                            type="text"
                                            name="ref"
                                            id="ref"
                                            #ref="ngModel"
                                            [ngModel]="payFormData.ref"
                                            placeholder="Ingresa el número de referencia del pago"
                                            autocomplete="off"
                                            inputmode="numeric"
                                            minlength="6"
                                            maxlength="6"
                                            pattern="[0-9]{6}"
                                            (input)="onReferenceInput($event)"
                                            (keypress)="onlyAllowReferenceNumbers($event)"
                                            [disabled]="canValidatePayment() && (isValidated || isValidating)"
                                            [ngClass]="{
                                                'is-invalid': canValidatePayment() && ref.touched && !ref.valid && !isValidated,
                                                'is-valid': canValidatePayment() && isValidated
                                            }"
                                            finaReferenceValidator
                                            [finaReferenceValidatorPhone]="paymentMethodSelected?.phone"
                                            [finaReferenceValidatorDni]="paymentMethodSelected?.dni"
                                        />
                                    </div>
                                    <div class="col-md-4">
                                        <button
                                            *ngIf="canValidatePayment() && !canSkipValidation"
                                            type="button"
                                            class="btn btn-purple w-100"
                                            [disabled]="!ref.valid || isValidated || isValidating || validationTimer > 0 || (isMixPurchaseFlow && refreshingMixRate)"
                                            (click)="validateReference()"
                                        >
                                            <span *ngIf="isValidating" class="spinner-border spinner-border-sm me-1" role="status"></span>
                                            <span *ngIf="validationTimer > 0 && !isValidating">{{ validationTimer }}s</span>
                                            <span *ngIf="!isValidating && validationTimer === 0">Verificar</span>
                                        </button>
                                    </div>
                                </div>

                                <div *ngIf="ref.touched && ref.invalid && !isValidated">
                                    <div class="invalid-feedback d-block" *ngIf="ref.errors?.['required']">La referencia es requerida.</div>
                                    <div class="invalid-feedback d-block" *ngIf="ref.errors?.['minlength'] || ref.errors?.['maxlength'] || ref.errors?.['pattern']">
                                        Debe contener exactamente 6 dígitos.
                                    </div>
                                    <div class="invalid-feedback d-block" *ngIf="ref.errors?.['forbiddenZeros']">La referencia no puede ser '000000'.</div>
                                    <div class="invalid-feedback d-block" *ngIf="ref.errors?.['forbiddenPhone']">No puede coincidir con los últimos 6 dígitos del teléfono.</div>
                                    <div class="invalid-feedback d-block" *ngIf="ref.errors?.['forbiddenDni']">No puede coincidir con los últimos 6 dígitos del RIF/Cédula.</div>
                                </div>

                                <div *ngIf="canValidatePayment() && validationError && !canSkipValidation" class="alert alert-danger mt-2 py-2" role="alert">
                                    <i class="fas fa-times-circle me-2"></i>
                                    {{ validationError }}
                                    <span *ngIf="validationAttempts > 0 && validationAttempts < manualReviewAttempts"> (Intento {{ validationAttempts }}/{{ manualReviewAttempts }}) </span>
                                </div>

                                <div
                                    *ngIf="canValidatePayment() && canSkipValidation && (skipDueToAmountMismatch || skipDueToStaging || skipDueToApplicationReview)"
                                    class="alert alert-warning mt-2 py-2"
                                    role="alert"
                                >
                                    <i class="fas fa-exclamation-triangle me-2"></i>
                                    {{ validationError }}
                                </div>

                                <div *ngIf="canValidatePayment() && canSkipValidation && !skipDueToAmountMismatch && !skipDueToStaging" class="alert alert-warning mt-2 py-2" role="alert">
                                    <i class="fas fa-exclamation-triangle me-2"></i>
                                    No se pudo verificar el pago después de {{ manualReviewAttempts }} intentos. Puedes continuar sin verificación, pero tu pago será revisado manualmente.
                                </div>
                            </div>

                            <div class="fpp-info-note fpp-info-note--bordered mb-3">
                                <fa-icon class="fpp-info-note__icon" [icon]="['fas', 'circle-info']"></fa-icon>
                                <span *ngIf="isSmsPurchaseFlow; else planActivationNote"> Los SMS se acreditarán automáticamente una vez el pago sea confirmado. </span>
                                <ng-template #planActivationNote>
                                    <span>La activación será automática una vez el pago sea efectivo.</span>
                                </ng-template>
                            </div>

                            <div class="mb-3 fpp-comments-block">
                                <label class="form-label fpp-label" for="comments"><b>Comentarios</b> <span class="text-muted">(opcional)</span></label>
                                <textarea
                                    class="form-control fpp-input"
                                    name="comments"
                                    id="comments"
                                    #comments="ngModel"
                                    [(ngModel)]="payFormData.comments"
                                    placeholder="Agrega comentarios adicionales sobre tu pago..."
                                    rows="3"
                                    autocomplete="off"
                                    [ngClass]="{ 'is-invalid': comments.touched && !comments.valid }"
                                ></textarea>
                                <div class="invalid-feedback" *ngIf="!comments.valid">Comentarios inválidos.</div>
                            </div>

                            <button
                                type="button"
                                class="btn btn-purple fpp-btn-primary w-100"
                                [disabled]="!Form.valid || loading || isValidationRequired() || !canAdvanceWithCoupon() || isBlockedByMissingFiscalInfo || (isMixPurchaseFlow && refreshingMixRate)"
                                (click)="payPlan()"
                            >
                                <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status"></span>
                                Reportar pago
                            </button>
                        </ng-container>
                    </ng-container>
                </div>

                <ng-template #postPaymentSurveyContent>
                    <fina-post-payment-survey (completed)="onPostPaymentSurveyCompleted()"></fina-post-payment-survey>
                </ng-template>

                <!-- ====================================================================== PAY_MODAL_STEP_3 — Éxito (extraer a componente dedicado) -->
                <div *ngIf="payModalStep === 3" class="fpp-step fpp-step--3 text-center py-4 px-2 my-5 mx-2">
                    <div id="pay-plan-confetti" class="fpp-confetti-animation"></div>
                    <h2 class="fpp-success-title mb-2">{{ paymentUnderReview ? 'Pago en revisión' : '¡Estás listo!' }}</h2>
                    <p class="fpp-success-subtitle mb-4">
                        {{
                            isSmsPurchaseFlow
                                ? smsPurchaseSuccessMessage || 'Compra de SMS reportada. Se acreditarán cuando el pago sea confirmado.'
                                : planPaymentSuccessMessage || 'Pago reportado correctamente.'
                        }}
                    </p>
                    <button type="button" class="btn btn-purple fpp-btn-primary px-5" (click)="acceptSuccessModal()">Aceptar</button>
                </div>
            </div>
        </ng-container>

        <ng-template #payModalLoading>
            <div class="modal-header fpp-modal-header border-0 pb-0">
                <div class="w-100">
                    <ng-container *ngIf="showSmsSection; else loadingPayOnlyHeader">
                        <ng-container *ngIf="showPlanSmsTabs; else loadingSmsOnlyHeader">
                            <h5 class="modal-title fpp-modal-title mb-1">Plan y SMS</h5>
                            <p class="fpp-modal-subtitle mb-0">Cambia tu plan o compra paquetes de SMS</p>
                        </ng-container>
                        <ng-template #loadingSmsOnlyHeader>
                            <h5 class="modal-title fpp-modal-title mb-1">Comprar SMS</h5>
                            <p class="fpp-modal-subtitle mb-0">Selecciona un paquete de SMS</p>
                        </ng-template>
                    </ng-container>
                    <ng-template #loadingPayOnlyHeader>
                        <h5 class="modal-title fpp-modal-title mb-1">Confirmar pago</h5>
                        <p class="fpp-modal-subtitle mb-0">Revisa tu plan, tus usuarios y elige cómo pagar.</p>
                    </ng-template>
                </div>
                <div class="box-btn-close-modal">
                    <button (click)="modal.dismiss('Close Click')" class="btn-close-modal rounded-circle" type="button" data-dismiss="modal" aria-label="Close">
                        <img src="assets/icons/svg/icon-btn-close-modal.svg" class="" alt="icon-close" />
                    </button>
                </div>
            </div>
            <div class="modal-body fpp-modal-body pt-2">
                <div class="fpp-step fpp-step--1 my-4 mx-2">
                    <div class="fpp-plan-sms-tabs" *ngIf="showPlanSmsTabs">
                        <button type="button" class="fpp-plan-sms-tab" [class.fpp-plan-sms-tab--active]="activePlanSmsTab === 'plan'" (click)="setPlanSmsTab('plan')">Cambiar plan</button>
                        <button type="button" class="fpp-plan-sms-tab" [class.fpp-plan-sms-tab--active]="activePlanSmsTab === 'sms'" (click)="setPlanSmsTab('sms')">Comprar SMS</button>
                    </div>

                    <ng-container *ngIf="!isSmsOnlyMode && (!showSmsSection || activePlanSmsTab === 'plan')">
                        <div class="fpp-skeleton" aria-busy="true" aria-label="Cargando planes">
                            <div class="fpp-plan-cards">
                                <div class="fpp-plan-card fpp-plan-card--skeleton" *ngFor="let _ of skeletonSlots">
                                    <span class="fpp-skel fpp-skel--circle"></span>
                                    <div class="fpp-plan-card__body">
                                        <div class="fpp-plan-card__copy">
                                            <span class="fpp-skel fpp-skel--title"></span>
                                            <span class="fpp-skel fpp-skel--desc"></span>
                                        </div>
                                        <span class="fpp-skel fpp-skel--price"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="fpp-section-label mt-4 mb-2">Frecuencia de pago</div>
                            <div class="fpp-frequency-row">
                                <span class="fpp-skel fpp-skel--chip" *ngFor="let _ of [1, 2, 3, 4]"></span>
                            </div>
                            <div class="fpp-summary-box fpp-summary-box--skeleton mt-4">
                                <span class="fpp-skel fpp-skel--row"></span>
                                <span class="fpp-skel fpp-skel--row"></span>
                                <span class="fpp-skel fpp-skel--row fpp-skel--row-total"></span>
                            </div>
                            <span class="fpp-skel fpp-skel--btn mt-4"></span>
                        </div>
                    </ng-container>

                    <div *ngIf="showSmsSection && (isSmsOnlyMode || activePlanSmsTab === 'sms')" class="fpp-skeleton" aria-busy="true" aria-label="Cargando paquetes SMS">
                        <span class="fpp-skel fpp-skel--btn mt-4"></span>
                    </div>
                </div>
            </div>
        </ng-template>
    </form>
</ng-template>
